import Vue from 'vue';
import App from './App';
import { router } from './router';
import HttpPlugin from './components/HttpPlugin';
import WechatPlugin from './components/WechatPlugin';
import filters from './components/filters';
import store from './components/store';
//import Ads from 'vue-google-adsense';

Vue.use(require('vue-script2'))
/*
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)
*/
Vue.use(HttpPlugin);
Vue.use(WechatPlugin);
Vue.config.ignoredElements = ["wx-open-subscribe"];
Object.keys(filters).forEach(name => Vue.filter(name, filters[name]));


new Vue({
  router,
  data:  store.state,
  el: '#app',
  render: h => h(App)
});

//系统错误捕获
const errorHandler = (error, vm)=>{
  console.error('抛出全局异常');
  console.error(vm);
  console.error(error);
  
}

Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);